export default "//file.bilionpass.com/japandx-portal/0.1.17/static/img/quote.d9a8979a-8578a9.svg";